import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/productos_premium',
      name: 'productos_premium',
      component: () => import('./views/Productos_premium.vue')
    },
    {
      path: '/productos',
      name: 'productos',
      component: () => import('./views/Productos.vue')
    },
    {
      path: '/nosotros',
      name: 'nosotros',
      component: () => import('./views/Nosotros.vue')
    },
    {
      path: '/sucursales',
      name: 'sucursales',
      component: () => import('./views/Sucursales.vue')
    },
    {
      path: '/contacto',
      name: 'contacto',
      component: () => import('./views/Contacto.vue')
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    return { x: 0, y: 0 }
  }
})
